// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__50UTY","col":"Table_col__2RTmU","fulfillmentStatus":"Table_fulfillmentStatus__11s8B","emailCol":"Table_emailCol__jeFyA"};